/**
 * Feb 2026 · Company profile shown on every printable document.
 *
 * SINGLE SOURCE OF TRUTH for the print header. At runtime this file's
 * `COMPANY` binding holds whatever the app booted with; the App-level
 * bootstrap swaps it via `setPrintCompany()` as soon as GET
 * /api/company-profile returns, and the AdminSettings page calls the
 * same swap immediately after PUT so the very next print picks up the
 * edit without a page refresh.
 *
 * The defaults below are the last-resort fallback used by the print
 * helper when the app hasn't yet fetched (or the tenant has no doc).
 */
const _DEFAULT_COMPANY = {
  name: "NARROW FABRIC MFG PVT LTD",
  tagline: "Elastic Weaving · Woven / Knitted / Jacquard",
  logo: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAyMDAgNzAnPjxyZWN0IHdpZHRoPScyMDAnIGhlaWdodD0nNzAnIGZpbGw9JyMxMTEnLz48dGV4dCB4PScyMCcgeT0nMzUnIGZvbnQtZmFtaWx5PSdIZWx2ZXRpY2EnIGZvbnQtc2l6ZT0nMjEnIGZpbGw9JyNmYWMxNGYnIGZvbnQtd2VpZ2h0PSdib2xkJz5ORkc8L3RleHQ+PHRleHQgeD0nMjAnIHk9JzU3JyBmb250LWZhbWlseT0nSGVsdmV0aWNhJyBmb250LXNpemU9JzknIGZpbGw9JyNlZWUnIGxldHRlci1zcGFjaW5nPScyJz5OQVJST1cgRkFCUklDPC90ZXh0Pjwvc3ZnPg==",
  logoWidth: 44,
  address: [
    "Plot 12, Industrial Estate",
    "Ahmedabad – 380015",
    "Gujarat, India",
  ].join("\n"),
  // REV · Statutory identifiers intentionally BLANK in the bundled fallback.
  // They MUST come from Company Profile Master via /company-profile/branding.
  // Never ship demo GSTIN/PAN/CIN/IEC/UDYAM — printing invented statutory
  // numbers is a document-compliance risk (fail safe to blank instead).
  gstin: "",
  pan: "",
  cin: "",
  iec: "",
  udyam: "",
  phone: "+91-79-2650-0000",
  email: "sales@narrowfabric.com",
  website: "www.narrowfabric.com",
};

// Mutable cache. print.js calls `getPrintCompany()` on every print so a
// runtime swap via `setPrintCompany()` (from AdminSettings.jsx or the App
// bootstrap) is picked up on the next click, no refresh needed.
let _company = { ..._DEFAULT_COMPANY };

export function setPrintCompany(next) {
  // Shallow-merge so partial payloads from the API don't wipe defaults.
  _company = { ..._DEFAULT_COMPANY, ...(next || {}) };
}
export function getPrintCompany() { return _company; }

// Legacy import compatibility — some pages import `{ COMPANY }` directly.
// We export the mutable ref so consumers see the latest values once a
// swap has occurred (they should prefer getPrintCompany()).
export const COMPANY = new Proxy({}, {
  get: (_t, prop) => _company[prop],
  ownKeys: () => Object.keys(_company),
  getOwnPropertyDescriptor: () => ({ enumerable: true, configurable: true }),
});

export default COMPANY;

